'use client';

import React, { useEffect, useState } from 'react';
import {
    hasAnyApiMock,
    isApiMockEnvironmentAllowed,
    registerApiMockPanelOpener,
} from '@/lib/dev/api-mock.utils';
import { DEV_PANEL_BANNER_TEST_ID } from './DevPanelHost.consts';
import { StoreDevPanel } from './StoreDevPanel';

export const DevPanelHost = (): React.ReactElement | null => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (!isApiMockEnvironmentAllowed()) {
            return;
        }
        registerApiMockPanelOpener(() => setIsOpen(true));
        return () => {
            registerApiMockPanelOpener(null);
        };
    }, []);

    if (!isApiMockEnvironmentAllowed()) {
        return null;
    }

    return (
        <React.Fragment>
            {hasAnyApiMock() && (
                <div
                    data-testid={DEV_PANEL_BANNER_TEST_ID}
                    style={{
                        position: 'fixed',
                        zIndex: 99,
                        background: 'red',
                        width: '100vw',
                        padding: '0.5em',
                        textAlign: 'center',
                        color: '#fff',
                    }}
                >
                    SOME ROUTES MOCKED
                </div>
            )}
            {isOpen && <StoreDevPanel onClose={() => setIsOpen(false)} />}
        </React.Fragment>
    );
};
